<template>
	<div class="air-partners-container">
		<!-- 航空运输 -->
		<section class="service-section air-transport" id="section1">
			<div class="container">
				<div class="section-header center">
					<h2 class="section-title">{{ $t('NavigationServices.airTitle') }}</h2>
					<p class="section-subtitle">{{ $t('NavigationServices.airDescription') }}</p>
				</div>
				<div class="airline-partners">
					<div class="partner-grid">
						<div class="partner-item" v-for="(airline, index) in airlines" :key="index">
							<img :src="getLogo(airline.logo)" :alt="airline.name" class="partner-logo" loading="lazy" />
							<span class="partner-name">{{ airline.name }}</span>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- 海运服务 -->
		<section class="service-section sea-transport">
			<div class="container">
				<div class="section-header center">
					<h2 class="section-title">{{ $t('NavigationServices.seaTitle') }}</h2>
					<p class="section-subtitle">{{ $t('NavigationServices.seaDescription') }}</p>
				</div>
				<div class="shipping-partners">
					<div class="partner-grid">
						<div class="partner-item" v-for="(item, index) in shippingLines" :key="index">
							<img :src="getLogo(item.logo)" :alt="item.name" class="partner-logo" loading="lazy"
								:style="index === 7 ? { width: '140px' } : {}" />
							<div class="partner-info">
								<span class="partner-name">{{ item.name }}</span>
								<!-- <span class="partner-code">{{ item.code }}</span> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- WCA 介绍 -->
		<section class="wca-section" id="wca">
			<div class="container">
				<div class="section-header center">
					<h2 class="section-title">
						{{ $t('NavigationServices.wcaTitle') }}
					</h2>
				</div>
				<div class="wca-content">
					<div class="wca-text">
						<p>{{ $t('NavigationServices.wcaDescription') }}</p>
					</div>
					<div class="wca-image">
						<!-- <img src="@/assets/images/logo_wcaworld.png" alt="WCA Member" class="wca-badge" loading="lazy" /> -->
						<img src="@/assets/images/logo_wcaworld1.png" alt="WCA Member" class="wca-badge" style="width: 70%;"
							loading="lazy" />
						<img src="@/assets/images/logo_wcaworld2.png" alt="WCA Member" class="wca-badge" loading="lazy" />
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	export default {
		name: 'Shipping',
		data() {
			return {

			};
		},
		computed: {
			airlines() {
				return this.$t('airlines')
			},
			shippingLines() {
				return this.$t('shippingLines')
			}
		},
		methods: {
			getLogo(filename) {
				return require(`@/assets/images/${filename}`);
			}
		}
	};
</script>

<style scoped>
	.air-partners-container {
		overflow-x: hidden;
	}

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 15px;
	}

	.service-section {
		padding: 60px 15px;
	}

	.section-header {
		margin-bottom: 80px;

		&.center {
			text-align: center;
		}

		.section-title {
			font-size: 42px;
			font-weight: 600;
			margin-bottom: 15px;
			color: #1a3e72;
			position: relative;
			display: inline-block;

			&::after {
				content: '';
				position: absolute;
				bottom: -15px;
				left: 0;
				width: 80px;
				height: 4px;
				background: linear-gradient(to right, #1a6fdf, #4facfe);
				border-radius: 2px;
			}
		}

		.section-subtitle {
			font-size: 18px;
			color: #6c757d;
			font-weight: 300;
			letter-spacing: 1px;
		}
	}

	.section-subtitle {
		text-align: center;
		max-width: 800px;
		margin: 0 auto 30px;
		font-size: clamp(1rem, 2vw, 1.1rem);
		line-height: 1.6;
		color: #666;
		padding: 0 10px;
	}

	/* WCA 样式 */
	.wca-section {
		--bg-color: #f7fbff;
		--text-color: #444;
		--accent-color: #0056b3;
		--heading-color: #003366;
		--min-text-width: 280px;
		--min-image-width: 200px;
		--badge-width: 150px;
		--content-gap: 40px;
		--feature-gap: 20px;

		background-color: var(--bg-color);
		padding: 80px 20px;
	}

	.section-header.center {
		text-align: center;
		margin-bottom: 30px;
	}

	.section-title {
		color: var(--heading-color);
		font-size: 2rem;
		margin-bottom: 10px;
	}

	.section-subtitle {
		color: var(--accent-color);
		font-size: 1.2rem;
		font-weight: 500;
	}

	.wca-content {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
		justify-content: space-between;
		gap: var(--content-gap);
		max-width: 1200px;
		margin: 0 auto;
	}

	.wca-text {
		flex: 1 1 55%;
		min-width: var(--min-text-width);
		font-size: 1.1rem;
		line-height: 1.8;
		color: var(--text-color);
	}

	.wca-features {
		margin-top: 30px;
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
		gap: var(--feature-gap);
	}

	.feature-item {
		background: white;
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
	}

	.feature-item h3 {
		color: var(--accent-color);
		margin-bottom: 8px;
		font-size: 1.1rem;
	}

	.wca-image {
		flex: 1 0 20%;
		min-width: var(--min-image-width);
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
		gap: 0px;
		align-items: center;
	}

	.badge-group {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 10px;
	}

	.wca-badge {
		width: 100%;
		max-width: var(--badge-width);
		height: auto;
		object-fit: contain;
	}

	.badge-caption {
		text-align: center;
		font-size: 0.9rem;
		color: var(--heading-color);
		font-weight: 500;
	}

	@media (max-width: 768px) {
		.wca-content {
			flex-direction: column;
		}

		.wca-text,
		.wca-image {
			flex: 1 1 100%;
		}

		.wca-image {
			margin-top: 30px;
			grid-template-columns: repeat(3, 1fr);
		}

		.section-title {
			font-size: 1.6rem;
		}
	}

	@media (max-width: 480px) {
		.wca-image {
			grid-template-columns: 1fr;
			gap: 20px;
		}

		.wca-features {
			grid-template-columns: 1fr;
		}
	}

	/* 合作伙伴网格样式 */
	.partner-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
		gap: 20px;
	}

	.partner-item {
		background: white;
		border-radius: 8px;
		padding: 15px;
		display: flex;
		flex-direction: column;
		align-items: center;
		box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
		transition: all 0.3s ease;
	}

	.partner-item:hover {
		transform: translateY(-3px);
		box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
	}

	.partner-logo {
		height: clamp(60px, 12vw, 80px);
		width: auto;
		margin-bottom: 10px;
		object-fit: contain;
	}

	.partner-name {
		font-weight: 600;
		text-align: center;
		font-size: clamp(0.9rem, 2vw, 1rem);
	}

	.partner-info {
		display: flex;
		flex-direction: column;
		text-align: center;
		width: 100%;
	}

	.partner-code {
		font-size: clamp(0.75rem, 1.8vw, 0.85rem);
		color: #888;
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.service-section {
			padding: 40px 10px;
		}

		.wca-content {
			flex-direction: column;
			text-align: center;
		}

		.partner-grid {
			grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
			gap: 15px;
		}

		.partner-item {
			padding: 12px;
		}
	}

	@media (max-width: 480px) {
		.section-title {
			font-size: 1.6rem;
		}

		.partner-grid {
			grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
			gap: 10px;
		}

		.partner-logo {
			height: 50px;
		}
	}
</style>